
import moment from "moment";
export const getProjectFullID = function (project) {
    var s = String(project.ID);
    while (s.length < 8) s = "0" + s;
    return project.Source + s;
}

export const dateFormat = function (str) {
    return str ? moment(str).format("YYYY-MM-DD") : "";
}

export const weekFormat = function (str) {
    return moment(str).format("dddd");
}

export const amountFormat = function (amount) {
    return (amount + "")
        .split("")
        .reverse()
        .join("")
        .replace(/(\d{3})(?=\d)/g, "$1,")
        .split("")
        .reverse()
        .join("");
}

export const hoursFormat = function (hours, minutes) {
    if (!minutes) return `${hours}小時`
    if (!hours) return `${minutes}分鐘`
    return `${hours}小時${minutes}分鐘`
}